import { FORTA_WHITE } from '../../../utils/colors';
import { SCHEDULE_ACTIVITY_COLORS } from './constants';

import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const CHILD_BACKGROUND_ADD_BUTTON_SX = {
  width: 180,
  height: 40,
  fontSize: '0.9rem',
  borderRadius: '8px',
  '& .MuiTypography-root': { fontSize: '0.75rem' },
};

export const CHILD_SECTION_LABEL_SX: SxProps<Theme> = {
  mb: 1,
  fontWeight: 'bold',
  textAlign: 'left',
};

export const CHILD_SCHEDULE_HEADING_SX: SxProps<Theme> = {
  fontWeight: 'bold',
  textAlign: 'left',
};

export const SCHEDULE_ACTIVITY_LEGEND_SX: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  mt: 1,
};

export const SCHEDULE_ACTIVITY_LEGEND_ITEM_SX: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  width: { xs: 165, sm: 200 },
  height: 40,
  px: 1.5,
  py: 0.75,
  color: FORTA_WHITE,
  fontSize: { xs: 10, sm: 14 },
  fontWeight: 500,
};

export const SCHEDULE_ACTIVITY_SELECT_MENU_SX: SxProps<Theme> = Object.fromEntries(
  Object.entries(SCHEDULE_ACTIVITY_COLORS).map(([activityType, backgroundColor]) => [
    `& .MuiMenuItem-root[data-value="${activityType}"]`,
    {
      backgroundColor,
      color: FORTA_WHITE,
      '&:hover, &.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: `${backgroundColor} !important`,
        color: FORTA_WHITE,
      },
    },
  ]),
);

export const SCHEDULE_ACTIVITY_SELECT_VALUE_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  columnGap: 1,
  minWidth: 0,
};

export const SCHEDULE_ACTIVITY_COLOR_DOT_SX: SystemStyleObject<Theme> = {
  width: 10,
  height: 10,
  borderRadius: '50%',
  flexShrink: 0,
};
